import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import './RunIt.css';
import CookieConsent from './CookieConsent';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const YT_ID = '9dLRyAwkvY8';

const SMS_LINK = 'sms:+15418713311?&body=RUNIT';
const SMS_NUMBER = '+1 (541) 871-3311';
const SMS_KEYWORD = 'RUN IT';
const IG_DM_URL = 'https://ig.me/m/iamkristenhinman?ref=w58564447';

const IMG = {
  hero:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/2t98fqnu_untitled-0235.webp',
  card1:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/bcnmv8c1_2-white-blazer-laughing.webp',
  before:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/25xqe1d5_IMG_3539%202.webp',
  after:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/bomvr3gb_IMG_4509.webp',
  team:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/afx23ryc_untitled-0368.webp',
  final:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/qoypfwin_6-white-blazer-coffee-sip.webp',
  prodSerum:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/0ddf71fc24a19b7e_Boards_IR%20Clinical%E2%84%A2%20Hair%20Thinning%20Defense_2026-06-04.webp',
  prodBeads:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/a594aadd556d751c_Boards_REJUVABEADS%E2%84%A2_2026-06-04.webp',
  prodSystem:
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/447e6d6d758326db_Boards_IR%20Clinical%E2%84%A2%20System_2026-08-15.webp',
};

const COUNTRY_CODES = [
  { code: '+1',    flag: '🇺🇸', label: '🇺🇸 United States +1' },
  { code: '+1 CA', flag: '🇨🇦', label: '🇨🇦 Canada +1' },
  { code: '+61',   flag: '🇦🇺', label: '🇦🇺 Australia +61' },
  { code: '+43',   flag: '🇦🇹', label: '🇦🇹 Austria +43' },
  { code: '+32',   flag: '🇧🇪', label: '🇧🇪 Belgium +32' },
  { code: '+1 DO', flag: '🇩🇴', label: '🇩🇴 Dominican Republic +1' },
  { code: '+33',   flag: '🇫🇷', label: '🇫🇷 France +33' },
  { code: '+49',   flag: '🇩🇪', label: '🇩🇪 Germany +49' },
  { code: '+353',  flag: '🇮🇪', label: '🇮🇪 Ireland +353' },
  { code: '+39',   flag: '🇮🇹', label: '🇮🇹 Italy +39' },
  { code: '+370',  flag: '🇱🇹', label: '🇱🇹 Lithuania +370' },
  { code: '+52',   flag: '🇲🇽', label: '🇲🇽 Mexico +52' },
  { code: '+64',   flag: '🇳🇿', label: '🇳🇿 New Zealand +64' },
  { code: '+507',  flag: '🇵🇦', label: '🇵🇦 Panama +507' },
  { code: '+48',   flag: '🇵🇱', label: '🇵🇱 Poland +48' },
  { code: '+34',   flag: '🇪🇸', label: '🇪🇸 Spain +34' },
  { code: '+41',   flag: '🇨🇭', label: '🇨🇭 Switzerland +41' },
  { code: '+44',   flag: '🇬🇧', label: '🇬🇧 United Kingdom +44' },
  { code: 'other', flag: '',   label: 'other (type full number with code)' },
];

const CONSENT_TEXT =
  "it's ok to text me about RUN IT. msg & data rates may apply. reply STOP anytime.";

const fireEvent = (name) => {
  axios
    .post(`${API}/track-click`, { link_id: name, timestamp: new Date().toISOString() })
    .catch(() => {});
  if (typeof window !== 'undefined') {
    if (typeof window.gtag === 'function') { try { window.gtag('event', name); } catch (e) {} }
    if (window.posthog && typeof window.posthog.capture === 'function') {
      try { window.posthog.capture(name); } catch (e) {}
    }
  }
};

const TextMeBlock = ({ variant = 'light', testIdSuffix = '' }) => (
  <div className={`ri-textme ri-textme-${variant}`}>
    <p className="ri-textme-intro">
      want me to text you? i&apos;ll answer your questions &amp; give you my honest feedback on whether this fits your life.
    </p>
    <a
      href={SMS_LINK}
      onClick={() => fireEvent(`runit_text_me${testIdSuffix ? '_' + testIdSuffix : ''}`)}
      className={`ri-btn ${variant === 'dark' ? 'ri-btn-lime' : 'ri-btn-ink'}`}
      data-testid={`text-me-button${testIdSuffix ? '-' + testIdSuffix : ''}`}
    >
      text me {SMS_KEYWORD} to {SMS_NUMBER} →
    </a>
    <p className="ri-textme-tiny">for U.S. &amp; Canada numbers. msg &amp; data rates may apply.</p>
    <p className="ri-textme-intl">
      outside the U.S.?{' '}
      <a
        href={IG_DM_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => fireEvent(`runit_ig_dm${testIdSuffix ? '_' + testIdSuffix : ''}`)}
        className="ri-textme-link"
        data-testid={`ig-dm-link${testIdSuffix ? '-' + testIdSuffix : ''}`}
      >
        DM me RUN IT on Instagram
      </a>.
    </p>
    <div className="ri-flag-row ri-flag-row-sm" aria-hidden="true">
      🇺🇸🇨🇦🇲🇽🇵🇦🇩🇴🇬🇧🇮🇪🇫🇷🇧🇪🇩🇪🇦🇹🇨🇭🇪🇸🇮🇹🇵🇱🇱🇹🇦🇺🇳🇿
    </div>
    <p className="ri-textme-sold">you can partner with me from any of these 18 countries + growing.</p>
  </div>
);

const WatchButton = ({ onClick, variant = 'ink', testid }) => (
  <>
    <button type="button" onClick={onClick} className={`ri-btn ri-btn-${variant}`} data-testid={testid}>
      watch the 26-minute breakdown →
    </button>
    <p className="ri-fine">just click play, it plays right here. no sign-up needed</p>
  </>
);

const BEFORE_AFTER = [
  {
    label: 'fine hair',
    before: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/9399e87b77abf041_1-fine-hair-before.jpg',
    after: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/ee2efc0115945b4d_2-fine-hair-after.jpg',
  },
  {
    label: 'curly hair',
    before: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/012867a1ce69c91b_3-curly-hair-before.jpg',
    after: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/3b2eab6a8ad430af_4-curly-hair-after.jpg',
  },
  {
    label: 'thinning hair',
    before: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/763a8f7a95c34ec6_5-thinning-hair-before.jpg',
    after: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/aacf49d7e74c54ab_6-thinning-hair-after.jpg',
  },
  {
    label: 'silver hair',
    before: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/746ad63f61f1cc67_7-silver-hair-before.jpg',
    after: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/06071e239b2cce82_8-silver-hair-after.jpg',
  },
  {
    label: 'long, color treated hair',
    before: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/bc45dbc779880002_9-long-hair-before.jpg',
    after: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/fd00a7a0e0d660d5_10-long-hair-after.jpg',
  },
];

const RECEIVED_TEXTS = [
  'Omg the shampoo made my scalp all tingly 😍 hair is soo soft after my first wash',
  "I can't stop touching my hair lol",
  "five minutes in the class two of the girls looked at me. They're like what did you do to your hair between yesterday and today because it looks amazing. I had to laugh.",
  "I just did my first wash!! I'm obsessed! My hair feels amazing!",
  'Throwing away the shampoo I was using because my god',
  'ONE WEEK, using the serum religiously. 12 months PP, and as someone who has always shed clumps of hair in the shower. Not a single strand of hair came off my head.',
];

const SENT_TEXTS = [
  { msg: 'my hairline started filling back in after a stretch of stress & hormones.', from: 'me' },
  { msg: "my mom's on GLP-1s & her hair is growing back.", from: 'my mom' },
];

const PRODUCTS = [];

const EXPERTS = [
  {
    photo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/82cf85d27b6d844a_michelle-mattingly-headshot.jpg',
    quote: 'hair loss is one of the first things my patients bring up, and for years i didn\u2019t have a topical i trusted. now i do, and recommending it doesn\u2019t take another appointment slot.',
    name: 'dr. michelle mattingly, ND, LAc',
    credentials: 'naturopathic doctor & acupuncturist',
    handle: '@drmichellemattingly',
    url: 'https://www.instagram.com/drmichellemattingly/',
  },
  {
    photo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/71446728d9315cf4_paige-lynch-headshot.jpg',
    quote: 'i read ingredient labels for a living, so i used these on myself first. they made the biggest difference. then my patients saw it too, and only then did i put my name on them.',
    name: 'paige s. lynch, NP',
    credentials: 'triple board certified NP & functional medicine practitioner',
    handle: '@paigeslynchnp',
    url: 'https://www.instagram.com/paigeslynchnp/',
  },
  {
    photo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_42ae7e88-0a5f-412b-8ec7-9252fc983514/artifacts/4e78573d1e34049a_jen-clemons-headshot.jpg',
    quote: 'i\u2019m a mother, a doctor and a teacher. i didn\u2019t need another job. this had to serve my patients, make sense in the work i already do, and give me a new way to use what i know.',
    name: 'dr. jen clemons, ND',
    credentials: 'naturopathic doctor · wise owl medicine',
    handle: '@drjenclemons',
    url: 'https://www.instagram.com/drjenclemons/',
  },
];

const RunIt = () => {
  const [videoOpen, setVideoOpen] = useState(false);
  const [submitOpen, setSubmitOpen] = useState(false);
  const [submittedFirstName, setSubmittedFirstName] = useState('');
  const [submittedFullName, setSubmittedFullName] = useState('');

  // form state
  const [form, setForm] = useState({
    name: '',
    country: '+1',
    phone: '',
    answer: '',
    consent: false,
    honeypot: '',
  });
  const [formError, setFormError] = useState('');
  const [serverError, setServerError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const closeVideo = useCallback(() => setVideoOpen(false), []);
  const openVideo = useCallback(() => {
    fireEvent('runit_watch_video');
    setVideoOpen(true);
  }, []);

  const closeSubmit = useCallback(() => setSubmitOpen(false), []);
  const openSubmit = useCallback(() => setSubmitOpen(true), []);

  const onFormChange = (field) => (e) => {
    const val = field === 'consent' ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [field]: val }));
    setFormError('');
    setServerError('');
  };

  const formatPhoneInternational = (country, phone) => {
    // Strip non-digits except leading +, then prefix country code
    const digits = phone.replace(/[^\d]/g, '');
    if (country === 'other') {
      return phone.trim().startsWith('+') ? phone.trim().replace(/\s+/g, '') : `+${digits}`;
    }
    const cc = country.replace(/[^\d]/g, ''); // e.g. +1 CA -> 1
    return `+${cc}${digits}`;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return setFormError('add your name so i know who you are.');
    if (!form.phone.trim() && form.country !== 'other') return setFormError('add your mobile number so i can text you.');
    if (form.country === 'other' && !form.phone.trim()) return setFormError('add your mobile number so i can text you.');
    if (!form.answer.trim()) return setFormError('tell me what you want your money to change. one line is plenty.');
    if (!form.consent) return setFormError('check the box so i can text you.');

    setSubmitting(true);
    setServerError('');
    try {
      const phoneIntl = formatPhoneInternational(form.country, form.phone);
      await axios.post(`${API}/leads`, {
        name: form.name.trim(),
        phone: phoneIntl,
        country_code: form.country,
        answer: form.answer.trim(),
        consent: true,
        consent_text: CONSENT_TEXT,
        source_url: typeof window !== 'undefined' ? window.location.href : '',
        honeypot: form.honeypot,
      });
      fireEvent('runit_application_submitted');
      const first = form.name.trim().split(' ')[0].toLowerCase();
      setSubmittedFirstName(first);
      setSubmittedFullName(form.name.trim());
      // clear form
      setForm({ name: '', country: '+1', phone: '', answer: '', consent: false, honeypot: '' });
      openSubmit();
    } catch (err) {
      setServerError(
        'something went wrong on my end. text me RUN IT at +1 (541) 871-3311 instead.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!videoOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') closeVideo(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [videoOpen, closeVideo]);

  useEffect(() => {
    if (!submitOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') closeSubmit(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [submitOpen, closeSubmit]);

  // Scroll to #apply if hash present on mount
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash === '#apply') {
      setTimeout(() => {
        const el = document.getElementById('apply');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 400);
    }
  }, []);

  const questions = [
    { q: '"okay, but how does it actually work?"', a: 'you share products you actually use. people order through your link and a few days later it shows up at their house. you earn commission on those orders, and bonuses when you help other women start too. we get paid five times a month. every friday, plus the 15th.' },
    { q: '"can i just share links without building a team?"', a: 'yes. monat has a direct integration with meta & tiktok shop, so you can tag products in your content and earn up to 45% commission. most brands pay 5–15% and keep the customer. here there\'s no cap on commissions and the customer is yours. (monat sold $1 million in one month on tiktok shop alone.)' },
    { q: '"do i need to be on social media?"', a: 'no. our top income earner just crossed $10 million in commissions earned (not sold), and she built her first million entirely in person. that\'s how i\'m building my business too, with a focus on community.' },
    { q: '"i\'ve done network marketing before."', a: 'so have a lot of the women on my team. there are no quotas here. no monthly spend requirements. you don\'t have to stock anything.' },
    { q: '"what does it cost to start?"', a: 'around $300, and that\'s your products to actually use on yourself. i always joke that you can come in for the price of shampoo. you\'ll either have amazing hair or we\'ll be millionaires together.' },
    { q: '"what if the products aren\'t for me?"', a: "there's a 30-day money-back guarantee. if you tell me \"kristen, the products aren't for me,\" i'm like, great. no problem." },
  ];

  const ranks = [
    ['market partner', '$7'], ['associate market partner', '$74'], ['managing market partner', '$147'],
    ['associate market builder', '$328'], ['market builder', '$582'], ['managing market builder', '$943'],
    ['associate market mentor', '$2,175'], ['market mentor', '$5,093'], ['managing market mentor', '$12,142'],
    ['associate executive director', '$25,515'], ['executive director', '$40,220'], ['senior executive director', '$102,318'],
  ];

  const applySmsBody = encodeURIComponent(`RUN IT · i just applied! it's ${submittedFullName}`);
  const applySmsLink = `sms:+15418713311?&body=${applySmsBody}`;

  return (
    <div className="ri-page">
      <main className="ri-container">
        {/* HERO */}
        <section className="ri-hero" data-testid="hero-section">
          <button
            type="button"
            className="ri-video-poster"
            onClick={openVideo}
            aria-label="Play the 26-minute breakdown"
            data-testid="hero-watch-button"
          >
            <img src={`https://img.youtube.com/vi/${YT_ID}/maxresdefault.jpg`} alt="26-minute breakdown video" loading="eager" />
            <span className="ri-video-shade" aria-hidden="true" />
            <span className="ri-video-play" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor" /></svg>
            </span>
            <span className="ri-video-poster-label">watch the 26-minute breakdown →</span>
          </button>
          <div className="ri-hero-copy">
            <div className="ri-eyebrow"><span className="ri-rule" />kristen hinman</div>
            <h1 className="ri-h1" data-testid="hero-headline">ready to run</h1>
            <div className="ri-hero-sticker-wrap">
              <span className="ri-hero-sticker" data-testid="hero-sticker">run it</span>
            </div>
            <p className="ri-hero-body">
              i help women get paid more for what they&apos;ve already built.
            </p>
            <p className="ri-fine">just click play, it plays right here. no sign-up needed</p>
          </div>
        </section>

        <TextMeBlock variant="dark" testIdSuffix="hero" />

        {/* CARD 1 */}
        <article className="ri-card ri-card-photo" data-testid="card-kristen">
          <div className="ri-photo-slot"><img src={IMG.card1} alt="Kristen laughing in a white blazer" /></div>
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />hi, i&apos;m kristen</div>
            <h2 className="ri-headline">i&apos;ve had my own business for over a decade.</h2>
            <div className="ri-text">
              <p>different versions of it. and the only time i got paid in that decade was when i was actively working. pushing something forward, creating an offer, working face-to-face with people.</p>
              <p>if you do service work, you know exactly what i mean. your income is tied to how many hours you&apos;re putting in.</p>
              <p>and you love your work. which is probably why it took you so long to question how much of you it requires.</p>
            </div>
          </div>
        </article>

        {/* CARD 2 */}
        <article className="ri-card" data-testid="card-two-summers">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />two summers</div>
            <h2 className="ri-headline">the launch worked. that was actually the problem.</h2>
            <div className="ri-text">
              <p>a couple summers ago i made about $5k on a launch right before we left for two months in europe. i built it so i could deliver it while we were gone, and i did.</p>
              <p>then the $5k was gone. and so was the momentum i used to make it.</p>
              <p>so september comes and i&apos;m sitting back down at my computer like, what am i selling now? where did my momentum go?</p>
              <p>okay. go time.</p>
              <p>nothing was wrong with my business. it worked. every dollar just asked me to create the conditions to make the next one.</p>
              <p>so i did something i never thought i&apos;d do. i added a second business model beside my coaching. one where i don&apos;t create the product, write the sales page or start over every launch. i share products i actually use, i help other women do the same, and it keeps paying me after the work is done.</p>
              <p>this summer was different.</p>
              <p>life was lifing. the kids were home. it felt like we were in a pressure cooker all summer.</p>
              <p>i didn&apos;t have it in me to build anything that season. my family needed me.</p>
              <p>and in august, right before the kids went back to school, i looked back and realized i had been paid every week and on the 15th of the month. for the relationships i already had.</p>
              <p>that was an entirely new experience for me.</p>
            </div>
          </div>
        </article>

        {/* CARD 3 — shampoo */}
        <article className="ri-card ri-card-photo ri-card-photo-reverse" data-testid="card-shampoo">
          <div className="ri-photo-slot ri-photo-slot-ba">
            <div className="ri-ba-pair">
              <figure className="ri-ba-item"><img src={IMG.before} alt="before" /><figcaption className="ri-ba-label ri-ba-label-before">BEFORE</figcaption></figure>
              <figure className="ri-ba-item"><img src={IMG.after} alt="after" /><figcaption className="ri-ba-label ri-ba-label-after">AFTER</figcaption></figure>
            </div>
          </div>
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />the shampoo part</div>
            <h2 className="ri-headline">&ldquo;selling shampoo&rdquo; is funny because technically, yes. that is what i do.</h2>
            <div className="ri-text">
              <p>but it leaves out almost everything that made me interested in this business.</p>
              <p>i know how to make money by creating something, selling it &amp; delivering it. i&apos;m good at that. i also know how much of me that can require.</p>
              <p>what i wanted to know was whether i could take everything i already knew how to do &amp; put it inside a business where i didn&apos;t have to create the product, build the sales page, fulfill the offer or start the whole machine over every few months.</p>
              <p>because then you get to choose. do i want to spend more time doing what i love? do i want to take on more clients? or fewer?</p>
              <p>and the products had to be good enough to put my name on. tbh i&apos;m pretty minimal with my hair. what changed it wasn&apos;t a ten-step routine. it was consistency. using a line that&apos;s basically functional medicine for your hair, that actually works, week after week.</p>
              <p>i&apos;m still a regular person who sells shampoo. i just have much bigger plans for what can be built around it.</p>
            </div>
          </div>
        </article>

        {/* NEW — RESULTS */}
        <article className="ri-card ri-card-results" data-testid="card-results">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />the results</div>
            <h2 className="ri-headline">clinical grade, for every hair type.</h2>
            <div className="ri-text">
              <p>functional medicine meets luxury haircare. plant-based, clinically studied &amp; made to pass EU standards.</p>
              <p>and it works on hair that looks nothing like mine. fine, curly, thinning, silver, postpartum.</p>
            </div>

            <div className="ri-ba-scroller" data-testid="ba-scroller">
              {BEFORE_AFTER.map((pair) => (
                <div className="ri-ba-tile" key={pair.label} data-testid={`ba-${pair.label.replace(/\s+/g, '-')}`}>
                  <div className="ri-ba-pair-grid">
                    <figure className="ri-ba-cell">
                      <img src={pair.before} alt={`${pair.label} before`} loading="lazy" />
                      <figcaption className="ri-ba-pill ri-ba-pill-before">BEFORE</figcaption>
                    </figure>
                    <figure className="ri-ba-cell">
                      <img src={pair.after} alt={`${pair.label} after`} loading="lazy" />
                      <figcaption className="ri-ba-pill ri-ba-pill-after">AFTER</figcaption>
                    </figure>
                  </div>
                  <p className="ri-ba-caption">{pair.label}</p>
                </div>
              ))}
            </div>
            <p className="ri-ba-swipe-hint" data-testid="ba-swipe-hint">swipe for more →</p>

            <div className="ri-prod-divider" aria-hidden="true" />
            <div className="ri-prod-seen-label">what the texts sound like</div>

            <div className="ri-chat-grid">
              {RECEIVED_TEXTS.map((text, i) => (
                <div className="ri-chat-row ri-chat-row-received" key={`r-${i}`}>
                  <div className="ri-bubble ri-bubble-received">{text}</div>
                </div>
              ))}
              {SENT_TEXTS.map((t, i) => (
                <div className="ri-chat-row ri-chat-row-sent" key={`s-${i}`}>
                  <div className="ri-bubble ri-bubble-sent">{t.msg}</div>
                  <span className="ri-bubble-from">{t.from}</span>
                </div>
              ))}
            </div>

            <div className="ri-prod-band">
              <p className="ri-prod-band-big">3 million+ customers.</p>
              <p className="ri-prod-band-small">zero compromise on ingredients.</p>
            </div>

            <p className="ri-prod-fine">
              photos &amp; messages are real customer experiences. individual results vary. product statements come from monat &amp; haven&apos;t been evaluated by the FDA. these products aren&apos;t intended to diagnose, treat, cure or prevent any disease.
            </p>
          </div>
        </article>

        {/* CARD 4 — business */}
        <article className="ri-card ri-card-photo" data-testid="card-business">
          <div className="ri-photo-slot"><img src={IMG.team} alt="Kristen with women from her team in the sunroom" /></div>
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />the business</div>
            <h2 className="ri-headline">this is the part that compounds.</h2>
            <div className="ri-text">
              <p>in my coaching business, a client paid me once and the work was done. here, when a customer reorders, i get paid again. no new launch. no new offer.</p>
              <p>and when you help another woman start, her customers and her team start to count toward yours too. the work you did last month keeps paying you this month.</p>
              <p>and you&apos;re never building alone. you&apos;re on a team of women doing this beside their own work. we have a group chat. you can pop in with &ldquo;hey, someone just asked me this. what would you say?&rdquo; and you get direct access to me.</p>
              <p>it&apos;s not a one or the other thing. it gets to be both and.</p>
            </div>
          </div>
        </article>

        {/* NEW — EXPERTS */}
        <article className="ri-card ri-card-experts" data-testid="card-experts">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />the experts on my team</div>
            <h2 className="ri-headline">the women who read the labels first.</h2>
            <p className="ri-text">doctors &amp; practitioners who are market partners on my team. here&apos;s why they said yes.</p>

            <div className="ri-experts-grid">
              {EXPERTS.map((ex) => (
                <div className="ri-expert-card" key={ex.handle} data-testid={`expert-${ex.handle.replace('@','')}`}>
                  <div className="ri-expert-bubble">
                    <p>{ex.quote}</p>
                  </div>
                  <div className="ri-expert-id">
                    <div className="ri-expert-photo">
                      <img src={ex.photo} alt={ex.name} loading="lazy" />
                    </div>
                    <div className="ri-expert-meta">
                      <p className="ri-expert-name">{ex.name}</p>
                      <p className="ri-expert-cred">{ex.credentials}</p>
                      <a
                        href={ex.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ri-expert-handle"
                        onClick={() => fireEvent(`runit_expert_${ex.handle.replace('@','')}`)}
                        data-testid={`expert-link-${ex.handle.replace('@','')}`}
                      >
                        {ex.handle}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <p className="ri-prod-fine">
              all three are independent monat market partners on my team. individual results vary.
            </p>
          </div>
        </article>

        {/* CARD 5 — questions */}
        <article className="ri-card" data-testid="card-questions">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />ask me anything</div>
            <h2 className="ri-headline">what people usually ask me first.</h2>
            <div className="ri-qa-list">
              {questions.slice(0, 3).map(({ q, a }, i) => (
                <div className="ri-qa" key={i}>
                  <p className="ri-qa-q">{q}</p>
                  <p className="ri-qa-a">{a}</p>
                </div>
              ))}
              <div className="ri-qa" data-testid="qa-countries">
                <p className="ri-qa-q">&ldquo;can i partner with you if i don&apos;t live in the u.s.?&rdquo;</p>
                <p className="ri-qa-a">yes. you can partner with me if you live in any of these 18 countries, and the list keeps growing.</p>
                <div className="ri-flag-row ri-flag-row-lg" aria-hidden="true">
                  🇺🇸🇨🇦🇲🇽🇵🇦🇩🇴🇬🇧🇮🇪🇫🇷🇧🇪🇩🇪🇦🇹🇨🇭🇪🇸🇮🇹🇵🇱🇱🇹🇦🇺🇳🇿
                </div>
                <p className="ri-qa-a">and your people don&apos;t have to live where you do. you can share with friends wherever they are. i lived in spain for two years, so this one&apos;s personal for me.</p>
                <p className="ri-qa-a">DM me RUN IT on instagram &amp; tell me where you live.</p>
              </div>
              <p className="ri-qa-sep">*</p>
              {questions.slice(3).map(({ q, a }, i) => (
                <div className="ri-qa" key={i + 3}>
                  <p className="ri-qa-q">{q}</p>
                  <p className="ri-qa-a">{a}</p>
                </div>
              ))}
              <div className="ri-qa">
                <p className="ri-qa-q">&quot;but are you making real money?&quot;</p>
                <p className="ri-qa-a">i think the better question is, what could another income stream actually change about your life?</p>
                <p className="ri-qa-a">and i&apos;d rather you see the real numbers than a screenshot. here&apos;s what market partners at every rank earn in an average month, straight from monat&apos;s income disclosure statement.</p>
              </div>
            </div>
            <div className="ri-income-table" role="table" aria-label="Monat income disclosure, average monthly gross earnings by rank">
              <div className="ri-income-head" role="row"><span>rank</span><span>avg. monthly gross earnings</span></div>
              {ranks.map(([rank, amt]) => (
                <div className="ri-income-row" role="row" key={rank}>
                  <span className="ri-income-rank">{rank}</span>
                  <span className="ri-income-amt">{amt}</span>
                </div>
              ))}
            </div>
            <p className="ri-text">most people start at the first rank. where you go from there depends on what you build. ask me &amp; i&apos;ll send you the full statement.</p>
            <p className="ri-note">*results not typical. see the average earnings by rank above.</p>
            <WatchButton onClick={openVideo} variant="ink" testid="questions-watch-button" />
          </div>
        </article>

        {/* PROOF */}
        <section className="ri-proof" data-testid="proof-card">
          <p>you don&apos;t need a huge following. you need the people who already trust you.</p>
        </section>

        {/* FINAL INK CARD */}
        <article className="ri-card ri-card-final ri-card-photo" data-testid="card-final">
          <div className="ri-photo-slot"><img src={IMG.final} alt="Kristen in a white blazer, sipping coffee" /></div>
          <div className="ri-card-body">
            <div className="ri-eyebrow ri-eyebrow-lime"><span className="ri-rule" />RUN IT</div>
            <h2 className="ri-headline ri-headline-oat">what do you want your money to change?</h2>
            <div className="ri-text ri-text-mushroom">
              <p>that&apos;s the first question i ask every woman before she starts with me. here&apos;s what they&apos;ve told me:</p>
              <p>peace.</p>
              <p>more time with their families.</p>
              <p>more impact.</p>
              <p>less trading time for money.</p>
              <p>if you already know what yours is, or you&apos;ve been wondering how selling shampoo actually turns into a business that tucks into everything you&apos;ve already built, start with the breakdown.</p>
            </div>
            <button type="button" className="ri-video-poster ri-video-poster-inline" onClick={openVideo} aria-label="Play the 26-minute breakdown" data-testid="final-watch-poster">
              <img src={`https://img.youtube.com/vi/${YT_ID}/maxresdefault.jpg`} alt="26-minute breakdown video" loading="lazy" />
              <span className="ri-video-shade" aria-hidden="true" />
              <span className="ri-video-play" aria-hidden="true"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor" /></svg></span>
              <span className="ri-video-poster-label">watch the 26-minute breakdown →</span>
            </button>
            <WatchButton onClick={openVideo} variant="lime" testid="final-watch-button" />
            <TextMeBlock variant="dark" testIdSuffix="final" />
            <p className="ri-mp-note">kristen hinman is an independent monat market partner.</p>
            <a href="https://monatglobal.com/income-disclosure-statement/" target="_blank" rel="noopener noreferrer" onClick={() => fireEvent('runit_income_disclosure')} className="ri-ids" data-testid="income-disclosure-link">income disclosure statement</a>
          </div>
        </article>

        {/* APPLICATION FORM */}
        <article id="apply" className="ri-card ri-card-apply" data-testid="card-apply">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />apply</div>
            <h2 className="ri-headline">apply to run it with me.</h2>
            <p className="ri-text">it takes a minute. i read every one myself &amp; text you back personally.</p>

            <form className="ri-form" onSubmit={onSubmit} noValidate data-testid="apply-form">
              {/* Honeypot (hidden) */}
              <input
                type="text"
                tabIndex="-1"
                autoComplete="off"
                aria-hidden="true"
                value={form.honeypot}
                onChange={onFormChange('honeypot')}
                className="ri-honeypot"
                name="company"
              />

              <label className="ri-field">
                <span className="ri-field-label">your name</span>
                <input
                  type="text"
                  value={form.name}
                  onChange={onFormChange('name')}
                  placeholder="first & last"
                  autoComplete="name"
                  data-testid="apply-name"
                />
              </label>

              <div className="ri-field">
                <span className="ri-field-label">mobile number</span>
                <div className="ri-phone-row">
                  <select
                    value={form.country}
                    onChange={onFormChange('country')}
                    className="ri-phone-country"
                    data-testid="apply-country"
                    aria-label="country code"
                  >
                    {COUNTRY_CODES.map((c) => (
                      <option key={c.code} value={c.code}>{c.label}</option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    value={form.phone}
                    onChange={onFormChange('phone')}
                    placeholder={form.country === 'other' ? 'full number with country code' : '(541) 555-0123'}
                    autoComplete="tel"
                    inputMode="tel"
                    className="ri-phone-input"
                    data-testid="apply-phone"
                  />
                </div>
              </div>

              <label className="ri-field">
                <span className="ri-field-label">what do you want your money to change?</span>
                <textarea
                  rows={3}
                  value={form.answer}
                  onChange={onFormChange('answer')}
                  placeholder="be specific. a car payment, daycare, more time with your kids. whatever's true for you."
                  data-testid="apply-answer"
                />
              </label>

              <label className="ri-check">
                <input
                  type="checkbox"
                  checked={form.consent}
                  onChange={onFormChange('consent')}
                  data-testid="apply-consent"
                />
                <span>{CONSENT_TEXT}</span>
              </label>

              {formError && <p className="ri-form-error" data-testid="apply-error">{formError}</p>}
              {serverError && <p className="ri-form-error" data-testid="apply-server-error">{serverError}</p>}

              <button
                type="submit"
                className="ri-btn ri-btn-ink"
                disabled={submitting}
                data-testid="apply-submit"
              >
                {submitting ? 'sending…' : 'send my application →'}
              </button>
            </form>
          </div>
        </article>

        {/* PRODUCTS ENDING */}
        <article className="ri-card ri-card-products" data-testid="card-products">
          <div className="ri-card-body">
            <div className="ri-eyebrow"><span className="ri-rule" />not ready to run?</div>
            <h2 className="ri-headline">start with <span className="ri-hl-lime">your hair.</span></h2>
            <p className="ri-text">you don&apos;t have to decide anything about the business today. plenty of people want to try the products first, &amp; that&apos;s a great place to start.</p>
            <p className="ri-text">answer 3 quick questions &amp; i&apos;ll send you the routine i&apos;d use for your hair.</p>
            <a
              href="https://leveragequiz.com/try-products?utm_source=run-it&utm_content=end"
              target="_blank"
              rel="noopener noreferrer"
              className="ri-btn ri-btn-lime ri-btn-products"
              onClick={() => {
                if (typeof window.fbq === 'function') { try { window.fbq('trackCustom', 'ProductsFromRunIt'); } catch (e) {} }
              }}
              data-testid="products-quiz-button"
            >
              find my hair routine →
            </a>
            <p className="ri-products-note" data-testid="products-note">a starting cart is usually $110 to $150, with a 30-day money-back guarantee.</p>
          </div>
        </article>

        {/* Footer */}
        <footer className="ri-footer" data-testid="footer">
          <p>
            kristen hinman is an independent monat market partner. ·{' '}
            <a href="https://monatglobal.com/income-disclosure-statement/" target="_blank" rel="noopener noreferrer" onClick={() => fireEvent('runit_income_disclosure_footer')} className="ri-footer-link" data-testid="footer-income-disclosure-link">
              income disclosure statement
            </a>{' '}available on request.
          </p>
        </footer>
      </main>

      {/* VIDEO OVERLAY */}
      {videoOpen && (
        <div className="ri-overlay" role="dialog" aria-modal="true" aria-label="26-minute breakdown" onClick={closeVideo} data-testid="video-overlay">
          <button type="button" className="ri-overlay-close" onClick={closeVideo} aria-label="Close video" data-testid="video-close-button">✕</button>
          <div className="ri-overlay-inner" onClick={(e) => e.stopPropagation()}>
            <div className="ri-video-wrap">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${YT_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1&enablejsapi=1`}
                title="26-minute breakdown"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                onLoad={(e) => {
                  try { e.target.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'); } catch (err) {}
                }}
              />
            </div>
            <div className="ri-overlay-after">
              <h3 className="ri-overlay-h">questions after watching?</h3>
              <TextMeBlock variant="dark" testIdSuffix="overlay" />
            </div>
          </div>
        </div>
      )}

      {/* SUBMIT MODAL */}
      {submitOpen && (
        <div
          className="ri-submit-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="application received"
          onClick={closeSubmit}
          data-testid="submit-overlay"
        >
          <div className="ri-submit-card" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="ri-submit-close"
              onClick={closeSubmit}
              aria-label="Close"
              data-testid="submit-close"
            >✕</button>

            <div className="ri-submit-check" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="28" height="28"><path d="M5 12l4 4L19 7" fill="none" stroke="#12140E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>

            <div className="ri-eyebrow ri-eyebrow-lime"><span className="ri-rule" />application received</div>
            <h3 className="ri-submit-h" data-testid="submit-heading">
              got it, {submittedFirstName}. your application is in.
            </h3>
            <p className="ri-submit-sub">i read every one myself, so you&apos;ll be hearing from me soon.</p>

            <div className="ri-submit-divider" />

            <div className="ri-submit-step">
              <span className="ri-submit-num">1</span>
              <div>
                <p className="ri-submit-step-h">text me RUN IT so i know it&apos;s you.</p>
                <p className="ri-submit-step-p">i answer texts faster than anything else, &amp; it puts your name at the top of my list.</p>
              </div>
            </div>
            <a
              href={applySmsLink}
              onClick={() => fireEvent('runit_submit_text_me')}
              className="ri-btn ri-btn-lime"
              data-testid="submit-text-me"
            >
              text me RUN IT →
            </a>
            <p className="ri-submit-tiny">
              or text <strong>RUN IT</strong> to <strong>{SMS_NUMBER}</strong> · outside the U.S.?{' '}
              <a href={IG_DM_URL} target="_blank" rel="noopener noreferrer" className="ri-textme-link" onClick={() => fireEvent('runit_submit_ig_dm')}>DM me RUN IT on Instagram</a>.
            </p>

            <div className="ri-submit-step">
              <span className="ri-submit-num">2</span>
              <div>
                <p className="ri-submit-step-h">watch the 26-minute breakdown</p>
                <p className="ri-submit-step-p">if you haven&apos;t yet, so we can skip straight to your questions.</p>
              </div>
            </div>
            <button
              type="button"
              className="ri-btn ri-btn-outline"
              onClick={() => { closeSubmit(); openVideo(); }}
              data-testid="submit-watch"
            >
              watch the breakdown →
            </button>

            <p className="ri-submit-close-line">
              the women who run with this are the ones who make the first move. so make it.
            </p>
          </div>
        </div>
      )}

      <CookieConsent />
    </div>
  );
};

export default RunIt;
